export const ACCOUNT_SWITCH_REASON_PARAM = 'reason';

export const ACCOUNT_SWITCH_NEXT_PARAM = 'next';

export const ACCOUNT_SWITCH_FALLBACK_NEXT = '/';

export const ACCOUNT_SWITCH_EMAIL_MASK = '***';
